"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTradeHistoryDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var MyTradeHistoryDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyTradeHistoryDetail, _super);
    function MyTradeHistoryDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金历史记录详情';
        _this.code = '106017';
        _this.desc = '基金历史记录详情';
        _this.requestParams = new zl_1.MyTradeHistoryDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyTradeHistoryDetail;
}(service_1.BaseService));
exports.MyTradeHistoryDetail = MyTradeHistoryDetail;
//# sourceMappingURL=myTradeHistoryDetail.js.map